import { render, staticRenderFns } from "./UpdateCustomerInfo.vue?vue&type=template&id=d90dc57e&scoped=true"
import script from "./UpdateCustomerInfo.vue?vue&type=script&lang=js"
export * from "./UpdateCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateCustomerInfo.vue?vue&type=style&index=0&id=d90dc57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90dc57e",
  null
  
)

export default component.exports